const PlagiarismCheckerProfessional=[
    {
        id:1,
        img:"./assests/images/essay-1.png",
        title:"Professional Faculty",
        desc:` Editors with native proficiency, qualification &amp; experience.
        `
    },
    {
        id:2,
        img:"./assests/images/assignment-2.png",
        title:"Affordable Fee",
        desc:"Economical prices for editing and proofreading services."
    },
    {
        id:3,
        img:"./assests/images/dissertation-3.png",
        title:"Prompt Delivery",
        desc:`We back up on time delivery through our refund policy.`
    },
    {
        id:4,
        img:"./assests/images/thesis-4.png",
        title:"Free Revisions",
        desc:`Free of charge revisions and final touches.`
    },

]

export default PlagiarismCheckerProfessional